import jwtDecode from 'jwt-decode';

interface DebugEntry {
	timestamp: string;
	category: string;
	message: string;
	data?: unknown;
}

const MAX_ENTRIES = 50;
const debugEntries: DebugEntry[] = [];

export const debugLog = (category: string, message: string, data?: unknown): void => {
	const timestamp = new Date().toISOString();
	const entry: DebugEntry = { timestamp, category, message, data };

	debugEntries.push(entry);
	if (debugEntries.length > MAX_ENTRIES) {
		debugEntries.shift();
	}

	if (data !== undefined) {
		console.warn(`[Editor Debug][${category}] ${message}`, data);
	} else {
		console.warn(`[Editor Debug][${category}] ${message}`);
	}
};

export const getDebugLog = (): readonly DebugEntry[] => [...debugEntries];

export interface TokenStatus {
	exists: boolean;
	expired: boolean | null;
	expiresAt: string | null;
	secondsRemaining: number | null;
}

export const debugTokenStatus = (): TokenStatus => {
	let token: string | null = null;
	try {
		token = localStorage.getItem('accessToken');
	} catch (e) {
		debugLog('auth', 'Failed to read accessToken from localStorage', e);
		return { exists: false, expired: null, expiresAt: null, secondsRemaining: null };
	}

	if (!token) {
		return { exists: false, expired: null, expiresAt: null, secondsRemaining: null };
	}

	let payload: { [key: string]: unknown };
	try {
		payload = jwtDecode<{ [key: string]: unknown }>(token);
	} catch {
		debugLog('auth', 'accessToken exists but could not be decoded');
		return { exists: true, expired: null, expiresAt: null, secondsRemaining: null };
	}

	if (typeof payload.exp !== 'number') {
		debugLog('auth', 'accessToken has no exp claim', { payloadKeys: Object.keys(payload) });
		return { exists: true, expired: null, expiresAt: null, secondsRemaining: null };
	}

	const nowSeconds = Math.floor(Date.now() / 1000);
	const secondsRemaining = payload.exp - nowSeconds;
	const expired = secondsRemaining <= 0;
	const expiresAt = new Date(payload.exp * 1000).toISOString();

	return { exists: true, expired, expiresAt, secondsRemaining };
};
